/**
 * Ported from plm/portal/ui/lib/quickTests/web/legacy/legacyUtils.js
 * Original: jQuery-based xssCleaner. Replaced with native DOM equivalent
 * so the React Portal build does not depend on jQuery.
 */

export function xssCleaner(unsafe) {
    const div = document.createElement('div');
    div.textContent = unsafe == null ? '' : unsafe;
    return div.innerHTML;
}

export default { xssCleaner };
